import {createStore} from 'vuex'

import { state } from '@/vuex/state'
import { getters } from '@/vuex/getters'
import * as actions from '@/vuex/actions'
import { mutations } from '@/vuex/mutations'

import geo from './geo'
import user from './user'
import project from './project'
import org from './org'
import billing from './billing'
import search from './search'
import layers from './layers'

const store = createStore({
  modules: {
    user,
    project,
    geo,
    org,
    billing,
    search,
    layers
  },
  state,
  actions,
  mutations,
  getters,
  plugins: []
})


export default store
